import React from 'react';
const List = () => {
  return /*#__PURE__*/React.createElement("h1", null, "List Page");
};
export { List };